<template>
  <div></div>
</template>

<script>
import { wxCodeInfo } from '@/api/api'
import wechattype from '../../utils/environment'
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {
    if (wechattype) {
      console.log('wechat02')

      wxCodeInfo(this.getQueryVariable('code')).then(res => {
        // document.cookie = `USER = ${JSON.stringify(res)}`
        if (res.wxOpenId) {
          let item = res
          localStorage.setItem('openId', res.wxOpenId)
          localStorage.setItem('userItem', JSON.stringify(item))
          let url =
            window.location.protocol +
            '//' +
            window.location.host +
            '/#/' +
            this.getQueryVariable('state') +
            this.getQueryString(decodeURIComponent(window.location.href))
          let queryString = this.getQueryString(
            decodeURIComponent(window.location.href)
          )
          window.location.href = url
          // this.$router.push({
          //   name:this.getQueryVariable('state'),
          //   query:this.getQueryData(queryString)
          // })
        }
      })
    } else {
      console.log('alipay02')
      console.log(this.getQueryVariable('auth_code'))

      wxCodeInfo(this.getQueryVariable('auth_code')).then(res => {
        // document.cookie = `USER = ${JSON.stringify(res.data)}`
        if (res.data.aliOpenId) {
          let item = res.data
          localStorage.setItem('openId', res.data.aliOpenId)
          localStorage.setItem('userItem', JSON.stringify(item))
          let url =
            window.location.protocol +
            '//' +
            window.location.host +
            '/#/' +
            this.getQueryVariable('state') +
            this.getQueryString(decodeURIComponent(window.location.href))
          let queryString = this.getQueryString(
            decodeURIComponent(window.location.href)
          )
          window.location.href = url
        }
      })
    }
  },
  methods: {
    getQueryVariable(variable) {
      let query = ''
      if (wechattype) {
        // 微信环境
        query = window.location.search.substring(1)
      } else {
        query = window.location.href.split('?')[1]
      }
      let vars = query.split('&')
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] == variable) {
          return pair[1]
        }
      }
      return false
    },
    getQueryString(href) {
      let str = href.substring(href.indexOf('#/'), href.length)
      let arr = str.split('?')
      if (arr.length == 1) {
        return ''
      } else {
        return '?' + arr[1]
      }
    },
    getQueryData(search) {
      let query = search.substring(1)
      let vars = query.split('&')
      let map = {}
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        map[pair[0]] = pair[1]
      }
      return map
    }
  }
}
</script>

<style scoped></style>
